import axios from "axios";
//const jipvioApiBase = process.env.JIPVIO_API_BASE;
const baseUriFilestoreSrv = `${process.env.VUE_APP_BASE_URL}/filestore/api/v1`;
export default {
  uploadMultipleFiles(formData) {
    return axios({
      method: "post",
      url: `${baseUriFilestoreSrv}/upload/multiple`,
      data: formData,
    })
      .then((res) => {
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail,
        };
      })
      .catch((err) => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류",
          },
        };
      });
  },
  downloadFile(fid) {
    return axios({
      method: "get",
      responseType: "blob",
      url: `${baseUriFilestoreSrv}/download/${fid}`,
    })
      .then((res) => {
        return {
          status: res.status,
          payload: res.data,
        };
      })
      .catch((err) => {
        // console.log(err);
        return {
          success: false,
          payload: {},
          detail: {
            code: -1,
            message: "서버통신 오류",
          },
        };
      });
  },
  deleteFile(fid) {
    return axios({
      method: "delete",
      url: `${baseUriFilestoreSrv}/${fid}`,
    })
      .then((res) => {
        return {
          status: res.status,
        };
      })
      .catch((err) => {
        // console.log(err);
        return {
          success: false,
          payload: {},
          detail: {
            code: -1,
            message: "서버통신 오류",
          },
        };
      });
  },
};
